import { useMemo } from 'react';

import Guest from '@components/Guest/Guest';
import DateInput from '@components/date-input/DateInput';

import {
  Wrapper,
  DateInputCol,
  DateInputRow,
  GuestItemWrapper,
  ChildAnimationErrorBox,
} from './styled';
import { Props } from './props';
import { validTourChildAge } from '../TourSelectionCard/helpers';

const TourRoomGuest = ({
  maxAdult = 3,
  maxChild = 2,
  guests,
  setGuests,
  validChildrenAges,
}: Props) => {
  const guestCount = useMemo(() => {
    let totalGuests = guests?.adultNumber ?? 0;
    if (guests?.childList?.length) {
      totalGuests += guests.childList.length;
    }
    return totalGuests;
  }, [guests]);
  // ==========================
  // Handle Adding new adult
  // ==========================
  const addAdult = () => {
    if (!validChildrenAges) return updateChildInfo();
    setGuests((val) => ({ ...val, adultNumber: val.adultNumber + 1 }));
  };

  // ==========================
  // Handle removing an adult
  // ==========================
  const removeAdult = () => {
    if (!validChildrenAges) return updateChildInfo();
    setGuests((val) => ({ ...val, adultNumber: val.adultNumber - 1 }));
  };

  // ==========================
  // Handle removing a child
  // ==========================
  const removeChild = () => {
    setGuests((currentVal) => ({
      ...currentVal,
      childList: currentVal.childList?.slice(0, -1),
    }));
  };

  // ==========================
  // Handle Adding new child
  // ==========================
  const addChild = () => {
    const newChildObject = {
      id: (guests.childList?.length || 0) + 1,
      date: null,
      error: false,
    };
    const updatedChildren = guests.childList?.length
      ? [...guests.childList, newChildObject]
      : [newChildObject];

    setGuests((currentVal) => ({ ...currentVal, childList: updatedChildren }));
  };

  // ==========================
  // Handle update child age
  // ==========================
  const changeChildDate = (id: number, date: Date | null) => {
    if (!id && !date) return;

    setGuests((currentVal) =>
      currentVal?.childList?.length !== 0
        ? {
            ...currentVal,
            childList:
              currentVal.childList &&
              currentVal.childList.map((kid) =>
                kid.id === id
                  ? {
                      ...kid,
                      date: date,
                      error: validTourChildAge(date) ? false : true,
                    }
                  : kid
              ),
          }
        : currentVal
    );
  };

  const updateChildInfo = () => {
    setGuests((currentVal) =>
      currentVal?.childList?.length !== 0
        ? {
            ...currentVal,
            childList:
              currentVal.childList &&
              currentVal.childList.map((kid) => ({
                ...kid,

                error: validTourChildAge(kid.date) ? false : true,
              })),
          }
        : currentVal
    );
  };

  return (
    <Wrapper>
      <GuestItemWrapper>
        <Guest
          key='adult'
          title='Yetişkin'
          subTitle='12+ Yaş'
          counterProps={{
            min: 1,
            disabledIncrement:
              guests.adultNumber === maxAdult || guestCount === 3,
            count: guests.adultNumber,
            handleDecrement: removeAdult,
            handleIncrement: addAdult,
            isTour: true,
          }}
        />
      </GuestItemWrapper>

      <GuestItemWrapper>
        <Guest
          key='child'
          title='Çocuk'
          subTitle=''
          counterProps={{
            count: guests.childList?.length || 0,
            handleDecrement: removeChild,
            handleIncrement: addChild,
            disabledIncrement:
              (guests.childList?.length || 0) >= maxChild || guestCount === 3,
            disabledDecrement: false,
            isTour: true,
          }}
        />
        {guests.childList?.length ? (
          <DateInputRow>
            {guests.childList.map((child, index) => (
              <DateInputCol key={child.id}>
                <div>
                  <ChildAnimationErrorBox hasError={!!child.error}>
                    <DateInput
                      dateFormat='dd/MM/yyyy'
                      label={`${index + 1}. Çocuk Doğum Tarihi`}
                      placeholder='DD/MM/YYYY'
                      date={child.date}
                      setDate={(e) => changeChildDate(child.id, e)}
                      error={child.error}
                      ageLimit={11}
                    />
                  </ChildAnimationErrorBox>
                </div>
              </DateInputCol>
            ))}
          </DateInputRow>
        ) : null}
      </GuestItemWrapper>
    </Wrapper>
  );
};

export default TourRoomGuest;
